import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { consumePostLoginRedirect } from '../utils/postLoginRedirect'

/**
 * Handles the OIDC callback after the provider redirects back.
 * Exchanges the authorization code for a Mana session (httpOnly cookie).
 */
const AuthCallback: React.FC = () => {
  const { loginWithCode, setError } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search)
      const code = params.get('code')
      const error = params.get('error')

      if (error) {
        setError(params.get('error_description') || error)
        navigate('/login')
        return
      }

      if (!code) {
        setError('認可コードが見つかりません')
        navigate('/login')
        return
      }

      const returnedState = params.get('state')
      const savedState = localStorage.getItem('oauth_state')
      if (!returnedState || returnedState !== savedState) {
        setError('無効な state パラメーター — CSRF 攻撃の可能性があります')
        localStorage.removeItem('oauth_state')
        navigate('/login')
        return
      }

      const codeVerifier = localStorage.getItem('pkce_code_verifier')
      const redirectUri = localStorage.getItem('pkce_redirect_uri')
      localStorage.removeItem('pkce_code_verifier')
      localStorage.removeItem('pkce_redirect_uri')
      localStorage.removeItem('oauth_state')

      try {
        // Exchange the code for a Mana session; the backend sets the httpOnly
        // session cookie. No token is handled in JavaScript.
        await loginWithCode(
          code,
          redirectUri || `${window.location.origin}/auth/callback`,
          codeVerifier || undefined,
        )
        navigate(consumePostLoginRedirect())
      } catch (err: any) {
        setError(err.message || '認証に失敗しました')
        navigate('/login')
      }
    }

    handleCallback()
  }, [])

  return (
    <div className="auth-form-container">
      <div className="auth-form-card">
        <p>サインインを完了しています...</p>
      </div>
    </div>
  )
}

export default AuthCallback
